var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-creator-image-area"},[_c('img',{staticClass:"image",attrs:{"src":_vm.value.image}}),_vm._l((_vm.areas),function(item,index){return _c('div',{key:index,staticClass:"item-area",style:(item.style)})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }